<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Disciples Emmaus" />
            <Disciples />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import Disciples from '../Les discipleEmmaius/DiscipleEmmaius.vue'


export default {
    name: 'DisciplesPage',
    components: {
        NavBar,
        PageTitle,
        Disciples,
        FooterComp,
    }
}
</script>